export default __webpack_public_path__ + "static/media/trash.196822ca.svg";